import React from 'react'
import { connect } from 'react-redux'
import { getQuestionIds } from '../selectors.js'
import QuestionNavLink from './QuestionNavLink.js'

const QuestionNav = ({ questionIds }) => {
  const Q = questionIds.map((id, i) => (
    <QuestionNavLink id={id} key={id} number={i + 1} />
  ))
  return <div>{Q}</div>
}

const mapStateToProps = state => ({
  questionIds: getQuestionIds(state),
})

export default connect(mapStateToProps)(QuestionNav)



// WEBPACK FOOTER //
// ./src/components/QuestionNav.js